// extracted by mini-css-extract-plugin
module.exports = {"attrib":"Person-styles-module--attrib--ZFXNY","image":"Person-styles-module--image--3FYJ9","text":"Person-styles-module--text--kiMZi"};